
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#d1d3d4","d":"M128.542 37.1l5.345 5.345L80.43 95.903l-5.346-5.346z"}}),_c('path',{attrs:{"fill":"#d1d3d4","d":"M75.26 90.564l-5.346 5.346-53.11-53.11 5.345-5.346z"}}),_c('circle',{attrs:{"cx":"75.01","cy":"94.56","r":"34.65","fill":"#e84325"}}),_c('path',{attrs:{"d":"M75 123.22a34.65 34.65 0 01-34.5-31.65c-.08 1-.14 2-.14 3a34.65 34.65 0 1069.3 0c0-1-.06-2-.14-3A34.65 34.65 0 0175 123.22z","fill":"#b62725"}}),_c('circle',{attrs:{"cx":"131.11","cy":"39.68","r":"18.89","fill":"#38b5df"}}),_c('path',{attrs:{"d":"M131.11 55.15A18.88 18.88 0 01112.31 38c0 .56-.09 1.13-.09 1.71a18.89 18.89 0 1037.78 0c0-.58 0-1.15-.09-1.71a18.87 18.87 0 01-18.8 17.15z","fill":"#0e8fbe"}}),_c('circle',{attrs:{"cx":"19.04","cy":"39.68","r":"18.89","fill":"#38b5df"}}),_c('path',{attrs:{"d":"M19 55.15A18.89 18.89 0 01.23 38c-.05.56-.08 1.13-.08 1.71a18.89 18.89 0 0037.78 0c0-.58 0-1.15-.09-1.71A18.88 18.88 0 0119 55.15z","fill":"#0e8fbe"}})])
          )
        }
      }
    